























































































































































































































































































































































































































































































































































































































































































































































import {
  CarpsaleHistoryManagementCarpsaleHistoryService,
  CarpsaleHistoryManagementEditOrderRequest,
  CarpsaleHistoryManagementEditOrderUnitRequest,
  CarpsaleHistoryManagementShowOrderResponse,
  StoreHistoryManagementEditOrderDetailRequest,
  StoreManagementListItemRequest,
} from "@/common/api";
import { DATE_TIME_FORMAT } from "@/common/constant";
import QCalendar from "@/common/qCalendar.vue";
import QErrors from "@/common/qErrors.vue";
import qNotify from "@/common/qNotify";
import paymentType = CarpsaleHistoryManagementEditOrderRequest.paymentType;
import { formatImageUrl } from "@/common/utils";
import LanguageComponent from "@/components/common/languageComponent.vue";
import PostalCode from "@/components/common/postalCode.vue";
import QInput from "@/components/common/qInput.vue";
import QInputNumber from "@/components/common/qInputNumber.vue";
import qSelectCarpsale from "@/components/common/qSelectCarpsale.vue";
import QUploadSingleImage from "@/components/common/qUploadSingleImage.vue";
import { TYPES as memberTypes } from "@/model/member";
import { STATUS_NAME_CARPSALE, TYPES } from "@/model/order";
import _ from "lodash";
import moment from "moment";
import { Component, Vue } from "vue-property-decorator";
import vSelect from "vue-select";

@Component({
  name: "CarpsaleHistoryEditComponent",
  computed: {
    paymentType() {
      return CarpsaleHistoryManagementEditOrderRequest.paymentType;
    },
    status() {
      return CarpsaleHistoryManagementEditOrderRequest.status;
    },
  },
  components: {
    QInputNumber,
    QInput,
    QCalendar,
    PostalCode,
    QErrors,
    LanguageComponent,
    QUploadSingleImage,
    vSelect,
    qSelectCarpsale,
  },
})
export default class AccountEditComponent extends Vue {
  public isShow = false;
  public errors = {};
  public orderDetails = [];
  public orderUnits = [];
  public errorStyle = {
    display: "flex",
    maxWidth: "100%",
    marginBottom: "0.8rem",
  };
  public totalGivePoint = 0;
  public otherId = -1;
  public inStoreId = -2;
  public defaultId = 0;
  public invoiceMemberAddressid = 0;
  public destinationMemberAddressid = 0;
  public items = [];

  public data: CarpsaleHistoryManagementShowOrderResponse = null;

  public deliveryTimes = [
    {
      label: "指定しない",
      value: "1",
    },
    {
      label: "午前中",
      value: "2",
    },
    {
      label: "14時〜16時",
      value: "3",
    },
    {
      label: "16時〜18時",
      value: "4",
    },
    {
      label: "18時〜20時",
      value: "5",
    },
    {
      label: "19時〜21時",
      value: "6",
    },
  ];

  public request: CarpsaleHistoryManagementEditOrderRequest = {
    id: null,
    invoiceMemberAddressid: null,
    invoiceName: null,
    invoiceZip: null,
    invoiceAddress1: null,
    invoiceAddress2: null,
    invoiceAddress3: null,
    invoiceTel: null,
    destinationMemberAddressid: null,
    destinationName: null,
    destinationZip: null,
    destinationAddress1: null,
    destinationAddress2: null,
    destinationAddress3: null,
    destinationTel: null,
    orderDetails: [],
    usePoint: 0,
    orderUnits: [],
    paymentType: CarpsaleHistoryManagementEditOrderRequest.paymentType.BANK,
    paymentLimitDate: null,
    deliveryPreferredDate: null,
    deliveryPreferredTime: 1,
    note: null,
    status: CarpsaleHistoryManagementEditOrderRequest.status.INITIAL,
    noteStaff: null,
  };

  public filter: StoreManagementListItemRequest = {
    nameOrCode: "",
    keyword: "",
    sort: "code",
    direction: StoreManagementListItemRequest.direction.ASC,
  };

  public origin: any = { ...this.data };

  get statusOptions() {
    return STATUS_NAME_CARPSALE;
  }

  public onChangePostalCode(address) {
    this.request.invoiceAddress1 = address.pref_name + address.city_name;
    this.changeInput("invoiceAddress1");
  }

  public onChangePostalCodeDestination(address) {
    this.request.destinationAddress1 = address.pref_name + address.city_name;
    this.changeInput("destinationAddress1");
  }

  public changeInput(key) {
    this.errors = { ...this.errors, ...{ [key]: [] } };
  }

  public async show(id) {
    this.reset();
    this.errors = {};

    await this.detail(id);

    this.origin = { ...this.data };
    this.isShow = true;
  }

  public async reset() {
    this.data = null;
    this.orderDetails = [];
    this.orderUnits = [];
    this.totalGivePoint = 0;
    this.items = [];

    this.request = {
      id: null,
      invoiceMemberAddressid: null,
      invoiceName: null,
      invoiceZip: null,
      invoiceAddress1: null,
      invoiceAddress2: null,
      invoiceAddress3: null,
      invoiceTel: null,
      destinationMemberAddressid: null,
      destinationName: null,
      destinationZip: null,
      destinationAddress1: null,
      destinationAddress2: null,
      destinationAddress3: null,
      destinationTel: null,
      orderDetails: [],
      usePoint: 0,
      orderUnits: [],
      paymentType: CarpsaleHistoryManagementEditOrderRequest.paymentType.BANK,
      paymentLimitDate: null,
      deliveryPreferredDate: null,
      deliveryPreferredTime: 1,
      note: null,
      status: CarpsaleHistoryManagementEditOrderRequest.status.INITIAL,
      noteStaff: null,
    };
  }

  public confirmCancel() {
    if (JSON.stringify(this.origin) === JSON.stringify(this.data)) {
      this.isShow = false;
    } else {
      this.$modal.showCancel({
        text: this.$t("common.message.cancel_confirm"),
        // we are passing callback method for our confirm button
        onConfirm: () => {
          this.isShow = false;
        },
      });
    }
  }

  public addItem() {
    this.orderDetails.push({
      id: null,
      is_sended: false,
      carpsale_item_id: null,
      price: 0,
      sale_price: 0,
      special_price: null,
      quantity: 1,
      isDeleted: false,
      code: null,
      option_names: null,
      is_give_point: false,
      item: null,
    });
  }

  public addUnit() {
    this.orderUnits.push({
      id: null,
      deliveryType:
        CarpsaleHistoryManagementEditOrderUnitRequest.deliveryType.YAMATO,
      deliveryPreferredDate: null,
      deliveryPreferredTime:
        CarpsaleHistoryManagementEditOrderUnitRequest.deliveryPreferredTime._1,
      shippingNumber: null,
      postage: 0,
      isDeleted: false,
    });
  }

  public deleteUnit(index) {
    this.orderUnits[index].isDeleted = true;
    this.clearError("orderUnits." + index + ".postage");
  }

  public deleteOrderDetails(index) {
    this.orderDetails[index].isDeleted = true;
    this.clearError("orderDetails." + index + ".itemId");
  }

  public formatImageUrl(fileName) {
    return formatImageUrl(fileName, "150x200", "contain");
  }

  public isCarpsaleBusiness() {
    if (
      this.data.order.type === TYPES.CARPSALE &&
      this.data.order.member.type === memberTypes.BUSINESS
    ) {
      return false;
    }
    return true;
  }

  get sumPrice() {
    let sum = 0;
    for (const detail of this.orderDetails.filter(
      (detail) => !detail.isDeleted,
    )) {
      sum += Number(
        detail.special_price
          ? detail.quantity * detail.special_price
          : detail.quantity * detail.price,
      );
    }

    return sum;
  }

  get sumUnitPrice() {
    let sum = 0;
    for (const unit of this.orderUnits.filter((unit) => !unit.isDeleted)) {
      sum += Number(unit.postage);
    }

    return sum;
  }

  get sumQuantity() {
    let sum = 0;
    for (const detail of this.orderDetails.filter(
      (detail) => !detail.isDeleted,
    )) {
      sum += Number(detail.quantity);
    }

    return sum;
  }

  get memberPoint() {
    let sum = 0;
    if (this.data) {
      for (const point of this.data.order.use_points) {
        sum += Number(point.use_point);
      }
    }

    const points = this.data.order.member?.member_points ?? [];
    const points_l = points.length;
    if (points_l > 0) {
      sum += Number(points[points_l - 1].point);
    }

    return sum;
  }

  get maxUsablePoint() {
    return Math.ceil(this.sumPrice);
  }

  public checkUsePoint() {
    let usablePoint = this.request.usePoint;
    if (this.request.usePoint > this.memberPoint) {
      usablePoint = this.memberPoint;
    }

    if (
      this.request.usePoint > this.maxUsablePoint + this.sumUnitPrice &&
      this.maxUsablePoint + this.sumUnitPrice < this.memberPoint
    ) {
      usablePoint = this.maxUsablePoint + this.sumUnitPrice;
    }

    this.request.usePoint = Number(usablePoint);
    this.calculateTotalGivePoint();
  }

  public updateIsGivePoint(event, index) {
    this.orderDetails[index].is_give_point = !event.target.checked;
    this.calculateTotalGivePoint();
  }

  public calculateTotalGivePoint() {
    if (this.data.order.is_pointed) {
      return (this.totalGivePoint = _.sumBy(
        this.data.order.give_points,
        "give_point",
      ));
    }
    let total = 0;
    for (const detail of this.orderDetails) {
      if (detail.is_give_point == true) {
        const currentPrice = detail.special_price
          ? detail.quantity * detail.special_price
          : detail.quantity * detail.price;
        total += currentPrice;
      }
    }
    this.totalGivePoint = Math.floor(
      (total - (this.request.usePoint ?? 0)) / 100,
    );
  }

  get finalPrice() {
    if (this.sumPrice + this.sumUnitPrice - this.request.usePoint < 0) {
      return 0;
    }

    return this.sumPrice - this.request.usePoint + this.sumUnitPrice;
  }

  public selectedItem(index, itemDetail) {
    itemDetail.code = itemDetail.item.code;
    itemDetail.name = itemDetail.item.name;
    itemDetail.option_names = null;
    itemDetail.company = itemDetail.item.company;
    itemDetail.price = itemDetail.item.price;
    itemDetail.special_price =
      itemDetail.item.sale_price && itemDetail.item.is_sale
        ? itemDetail.item.sale_price
        : null;
    itemDetail.image_name = itemDetail.item.image_name;
    itemDetail.carpsale_item_id = itemDetail.item.id;
    itemDetail.is_sale = itemDetail.item.is_sale;
    this.calculateTotalGivePoint();
    this.clearError("orderDetails." + index + ".itemId");
  }

  public optionNamesList(itemId) {
    if (!itemId) {
      return null;
    }
    const list = this.orderDetails.find((item) => item.item.id == itemId);
    if (!list) {
      return null;
    }
    if (!list.item) {
      return null;
    }
    if (!list.item.option_names) {
      return null;
    }
    const optionList = list.item.option_names.split("|");
    return optionList.map((item) => ({ key: item, value: item }));
  }

  public getItemList() {
    if (this.items.length === 0) {
      this.getItems(this.filter).then((items) => {
        this.items = [...items];
      });
    }
  }

  public async getItems(query = {}) {
    const result = await CarpsaleHistoryManagementCarpsaleHistoryService.adminCarpsaleHistoryItems(
      query,
    );
    return result.data.items;
  }

  public async detail(id) {
    try {
      const {
        data,
      } = await CarpsaleHistoryManagementCarpsaleHistoryService.adminCarpsaleHistoryShow(
        {
          id,
        },
      );

      this.data = { ...data };
      this.request.id = this.data.order.id;

      this.request.invoiceName = this.data.order.invoice_name;
      this.request.invoiceZip = this.data.order.invoice_zip;
      this.request.invoiceAddress1 = this.data.order.invoice_address1;
      this.request.invoiceAddress2 = this.data.order.invoice_address2;
      this.request.invoiceAddress3 = this.data.order.invoice_address3;
      this.request.invoiceTel = this.data.order.invoice_tel;
      this.request.invoiceMemberAddressid = this.searchInvoiceMemberAddressId();
      this.invoiceMemberAddressid = this.request.invoiceMemberAddressid;

      this.request.destinationName = this.data.order.destination_name;
      this.request.destinationZip = this.data.order.destination_zip;
      this.request.destinationAddress1 = this.data.order.destination_address1;
      this.request.destinationAddress2 = this.data.order.destination_address2;
      this.request.destinationAddress3 = this.data.order.destination_address3;
      this.request.destinationTel = this.data.order.destination_tel;
      this.request.deliveryType = this.data.order
        .delivery_type as CarpsaleHistoryManagementEditOrderRequest.deliveryType;
      this.request.destinationMemberAddressid = this.searchDestinationMemberAddressId();
      this.destinationMemberAddressid = this.request.destinationMemberAddressid;

      this.request.usePoint =
        this.data.order.used_s_points + this.data.order.used_l_points;
      this.request.paymentType = this.data.order.payment_type as paymentType;
      this.request.paymentLimitDate = this.data.order.payment_limit_date;
      this.request.deliveryPreferredDate = this.data.order.delivery_preferred_date;
      this.request.deliveryPreferredTime = this.data.order.delivery_preferred_time;
      this.request.note = this.data.order.note;
      this.request.status = this.data.order
        .status as CarpsaleHistoryManagementEditOrderRequest.status;
      this.request.noteStaff = this.data.order.note_staff;
      this.orderDetails = [];
      for (const detail of this.data.order.order_details) {
        this.orderDetails.push({
          id: detail.id,
          code: detail.code,
          name: detail.name,
          option_names: detail.option_names,
          company: detail.company,
          is_sended: detail.is_sended,
          carpsale_item_id: detail.carpsale_item_id,
          price: detail.price,
          sale_price: null,
          special_price: detail.special_price,
          quantity: detail.quantity,
          isDeleted: false,
          image_name: detail.image_name,
          is_sale: detail?.item?.is_sale,
          is_give_point: detail.is_give_point,
          item: detail.item,
        });
      }
      this.orderUnits = [];
      for (const unit of this.data.order.order_units) {
        this.orderUnits.push({
          id: unit.id,
          deliveryType: unit.delivery_type as CarpsaleHistoryManagementEditOrderUnitRequest.deliveryType,
          deliveryPreferredDate: unit.delivery_preferred_date,
          deliveryPreferredTime: unit.delivery_preferred_time,
          shippingNumber: unit.shipping_number,
          postage: Number(unit.postage),
          isDeleted: false,
        });
      }

      if (data.order.member.member_addresses.length > 0) {
        for (const address of data.order.member.member_addresses) {
          if (this.addressMatcher(address, this.data.order, "", "invoice_")) {
            this.request.invoiceMemberAddressid = address.id;
            this.invoiceMemberAddressid = address.id;
            break;
          }
        }

        for (const address of data.order.member.member_addresses) {
          if (
            this.addressMatcher(address, this.data.order, "", "destination_")
          ) {
            this.request.destinationMemberAddressid = address.id;
            this.destinationMemberAddressid = address.id;
            break;
          }
        }
      }
      this.calculateTotalGivePoint();
      this.origin = { ...this.data };
    } catch (error) {
      qNotify.error({
        text: error.message || "エラーが発生しました",
      });
    }
  }

  public async submit() {
    this.errors = {};
    let result;
    try {
      this.request.orderDetails = [];
      this.orderDetails = this.orderDetails.filter(
        (detail) => !(detail.isDeleted && detail.id == null),
      );
      for (const detail of this.orderDetails) {
        this.request.orderDetails.push({
          id: detail.id,
          isSended: detail.is_sended,
          itemId: detail.carpsale_item_id,
          specialPrice: detail.special_price,
          quantity: detail.quantity,
          isDeleted: detail.isDeleted,
          optionNames: detail.option_names,
          isGivePoint: detail.is_give_point,
        } as StoreHistoryManagementEditOrderDetailRequest);
      }

      this.request.orderUnits = this.orderUnits.filter(
        (unit) => !(unit.isDeleted && unit.id == null),
      );
      this.request.invoiceMemberAddressid = this.invoiceMemberAddressid;
      this.request.destinationMemberAddressid = this.destinationMemberAddressid;
      if (
        this.invoiceMemberAddressid == this.defaultId ||
        this.invoiceMemberAddressid == this.otherId
      ) {
        this.request.invoiceMemberAddressid = null;
      }
      if (
        this.destinationMemberAddressid == this.defaultId ||
        this.destinationMemberAddressid == this.otherId
      ) {
        this.request.destinationMemberAddressid = null;
      }
      result = await CarpsaleHistoryManagementCarpsaleHistoryService.adminCarpsaleHistoryEdit(
        this.request,
      );
    } catch (error: any) {
      result = error.body;
      this.errors = result.errors;
      if (Object.keys(this.errors).length === 0) {
        this.errors = {
          ...this.errors,
          ...{ memberPoint: error.body.message },
        };
      }
    }

    if (result.status == "success") {
      qNotify.success({
        text: this.$t("common.message.created"),
      });
      this.isShow = false;
      this.$emit("close");
    } else if (result.status == "400") {
      this.errors = {
        ...this.errors,
        ...{ memberPoint: result.body.message },
      };
    } else {
      qNotify.error({
        text: result.body.message,
      });
    }
  }

  get dateConfig() {
    return {
      dateFormat: "Y-m-d",
      enableTime: false,
      allowInput: false,
    };
  }

  public clearError(name) {
    this.errors = { ...this.errors, ...{ [name]: [] } };
  }

  public paymentTypeChange() {
    this.clearError("paymentLimitDate");
    if (this.request.paymentType == paymentType.C_O_D) {
      this.request.paymentLimitDate = null;
    }
  }

  public cancel() {
    // // check modifier form.
    // const diff = compareWithKeys(this.form, this.originalForm, [
    //   "title",
    //   "title_en",
    //   "title_cn",
    //   "image_id",
    //   "context",
    //   "context_en",
    //   "context_cn",
    //   "tag_ids",
    //   "open_status",
    //   "post_date",
    //   "release_setting",
    // ]);

    // if (!diff) {
    this.$modal.showCancel({
      text: `${this.$t("common.message.cancel_confirm")}`,
      onConfirm: () => {
        this.isShow = false;
      },
    });
    // } else {
    //   this.$router.push({ name: "admin.blog.index" });
    // }
  }

  public searchInvoiceMemberAddressId() {
    for (const address of this.data.order.member.member_addresses) {
      if (
        this.request.invoiceName == address.name &&
        this.request.invoiceZip == address.zip &&
        this.request.invoiceAddress1 == address.address1 &&
        this.request.invoiceAddress2 == address.address2 &&
        this.null2EmptyString(this.request.invoiceAddress3) ==
          this.null2EmptyString(address.address3) &&
        this.request.invoiceTel == address.tel
      ) {
        return address.id;
      }
    }
    const name =
      this.data.order.member.last_name +
      " " +
      this.data.order.member.first_name;
    if (
      this.null2EmptyString(this.request.invoiceName) ==
        this.null2EmptyString(name) &&
      this.null2EmptyString(this.request.invoiceZip) ==
        this.null2EmptyString(this.data.order.member.zip) &&
      this.null2EmptyString(this.request.invoiceAddress1) ==
        this.null2EmptyString(this.data.order.member.address1) &&
      this.null2EmptyString(this.request.invoiceAddress2) ==
        this.null2EmptyString(this.data.order.member.address2) &&
      this.null2EmptyString(this.request.invoiceAddress3) ==
        this.null2EmptyString(this.data.order.member.address3) &&
      this.null2EmptyString(this.request.invoiceTel) ==
        this.null2EmptyString(this.data.order.member.tel)
    ) {
      return this.defaultId;
    }

    return this.otherId;
  }

  public null2EmptyString(string) {
    if (string === null) {
      return "";
    }
    return string;
  }

  public addressMatcher(
    object1,
    object2,
    object1Prefix = "",
    object2Prefix = "",
  ) {
    const keys = ["name", "zip", "address1", "address2", "address3", "tel"];

    return keys.every((element) => {
      return (
        this.null2EmptyString(object1[object1Prefix + element]) ===
        this.null2EmptyString(object2[object2Prefix + element])
      );
    });
  }

  public searchDestinationMemberAddressId() {
    if (
      this.request.deliveryType ===
      CarpsaleHistoryManagementEditOrderRequest.deliveryType.STORE
    ) {
      return this.inStoreId;
    }
    for (const address of this.data.order.member.member_addresses) {
      if (
        this.request.destinationName == address.name &&
        this.request.destinationZip == address.zip &&
        this.request.destinationAddress1 == address.address1 &&
        this.request.destinationAddress2 == address.address2 &&
        this.null2EmptyString(this.request.destinationAddress3) ==
          this.null2EmptyString(address.address3) &&
        this.request.destinationTel == address.tel
      ) {
        return address.id;
      }
    }
    const name =
      this.data.order.member.last_name +
      " " +
      this.data.order.member.first_name;
    if (
      this.request.destinationName == name &&
      this.request.destinationZip == this.data.order.member.zip &&
      this.request.destinationAddress1 == this.data.order.member.address1 &&
      this.request.destinationAddress2 == this.data.order.member.address2 &&
      this.null2EmptyString(this.request.destinationAddress3) ==
        this.null2EmptyString(this.data.order.member.address3) &&
      this.request.destinationTel == this.data.order.member.tel
    ) {
      return this.defaultId;
    }

    return this.otherId;
  }

  public changeItemList(option, label, search) {
    return (
      option.code.toLocaleLowerCase().includes(search.toLocaleLowerCase()) ||
      option.name.toLocaleLowerCase().includes(search.toLocaleLowerCase())
    );
  }

  public getSelectedOption(itemId) {
    const itemSelected = this.data.order.order_details.find(
      (orderDetail) => orderDetail?.item?.id == itemId,
    );
    if (!itemSelected) {
      return null;
    }
    return itemSelected;
  }

  public onChangeStatus(event) {
    if (
      event.target.value ===
        CarpsaleHistoryManagementEditOrderRequest.status.CONFIRMED &&
      this.request.paymentType ===
        CarpsaleHistoryManagementEditOrderRequest.paymentType.BANK
    ) {
      const preferredDate = moment(this.request.deliveryPreferredDate).subtract(
        1,
        "days",
      );
      const limitDate = moment().add(10, "days");
      if (
        !this.request.paymentLimitDate &&
        !this.request.deliveryPreferredDate
      ) {
        this.request.paymentLimitDate = limitDate.format(DATE_TIME_FORMAT);
      } else if (
        !this.request.paymentLimitDate &&
        this.request.deliveryPreferredDate
      ) {
        this.request.paymentLimitDate = preferredDate.isBefore(limitDate)
          ? preferredDate.format(DATE_TIME_FORMAT)
          : limitDate.format(DATE_TIME_FORMAT);
      }
    }
  }

  public onChangeInvoiceAddress() {
    if (this.invoiceMemberAddressid == this.defaultId) {
      this.request.invoiceName =
        this.data.order.member.last_name +
        " " +
        this.data.order.member.first_name;
      this.request.invoiceZip = this.data.order.member.zip;
      this.request.invoiceAddress1 = this.data.order.member.address1;
      this.request.invoiceAddress2 = this.data.order.member.address2;
      this.request.invoiceAddress3 = this.data.order.member.address3;
      this.request.invoiceTel = this.data.order.member.tel;
    } else if (this.invoiceMemberAddressid) {
      const address = this.data.order.member.member_addresses.find(
        (address) => address.id == this.invoiceMemberAddressid,
      );
      this.request.invoiceName = address?.name;
      this.request.invoiceZip = address?.zip;
      this.request.invoiceAddress1 = address?.address1;
      this.request.invoiceAddress2 = address?.address2;
      this.request.invoiceAddress3 = address?.address3;
      this.request.invoiceTel = address?.tel;
    }
  }

  public onChangeDestinationAddress() {
    if (this.destinationMemberAddressid == this.defaultId) {
      this.request.destinationName =
        this.data.order.member.last_name +
        " " +
        this.data.order.member.first_name;
      this.request.destinationZip = this.data.order.member.zip;
      this.request.destinationAddress1 = this.data.order.member.address1;
      this.request.destinationAddress2 = this.data.order.member.address2;
      this.request.destinationAddress3 = this.data.order.member.address3;
      this.request.destinationTel = this.data.order.member.tel;
    } else if (this.destinationMemberAddressid) {
      const address = this.data.order.member.member_addresses.find(
        (address) => address.id == this.destinationMemberAddressid,
      );
      this.request.destinationName = address?.name;
      this.request.destinationZip = address?.zip;
      this.request.destinationAddress1 = address?.address1;
      this.request.destinationAddress2 = address?.address2;
      this.request.destinationAddress3 = address?.address3;
      this.request.destinationTel = address?.tel;
    }
  }

  public isShowUnit() {
    if (
      this.destinationMemberAddressid === this.inStoreId &&
      this.orderUnits.length === 0
    ) {
      return false;
    }
    return true;
  }
}
